(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.abortController = null;
    }

    connectedCallback() {
      this.productUrl = this.dataset.productUrl;
      this.sectionId = this.dataset.section;
      this.changeURL = this.dataset.changeUrl === 'true';
      this.addButton = document.querySelector(`#product-form-${this.sectionId} [name="add"]`);
      this.inputField = document.querySelector(`#product-form-${this.sectionId} [name="id"]`);

      this.addEventListener('change', (event) => {
        const optionValues = this.selectedOptionValues.join(',');
        const requestUrl = `${this.productUrl}?section_id=${this.sectionId}&option_values=${optionValues}`;
        this.renderProductInfo(requestUrl, this.productUrl, this.sectionId, this.changeURL);
      });
    }

    renderProductInfo(requestUrl, productUrl, sectionId, changeURL) {
      this.abortController?.abort();
      this.abortController = new AbortController();

      fetch(requestUrl, { signal: this.abortController.signal })
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const variantElement = html.querySelector('variant-selects [data-selected-variant]');
          const variantData = variantElement ? variantElement.textContent : null;
          const variant = variantData ? JSON.parse(variantData) : null;

          if (!variant) {
            this.addBtnText(true, window.variantStrings.unavailable, this.addButton);
            return;
          }

          this.inputField.value = variant.id;
          this.addBtnText(!variant.available, window.variantStrings.soldOut, this.addButton);

          if (changeURL) {
            const newUrl = `${productUrl}${variant ? `?variant=${variant.id}` : ''}`;
            window.history.replaceState({}, '', newUrl);
          }

          this.updateSourceFromDestination(['price', 'personalization'], sectionId, html);

          publish(PUB_SUB_EVENTS.variantChange, {
            data: { sectionId: this.sectionId, html, variant },
          });
        })
        .catch((error) => {
          if (error.name === 'AbortError') {
            console.log('Fetch aborted by user');
          } else {
            console.error(error);
          }
        });
    }

    addBtnText(disable, text, btnElement) {
      if (!btnElement) return;
      btnElement.disabled = disable;
      const span = btnElement.querySelector('span');
      if (!span) return;
      if (disable) {
        if (text) span.textContent = text;
      } else {
        span.textContent = window.variantStrings.addToCart;
      }
    }

    updateSourceFromDestination(selectors, sectionId, html) {
      selectors.forEach((selector) => {
        const destination = document.querySelector(`[data-${selector}-${sectionId}]`);
        const source = html.querySelector(`[data-${selector}-${sectionId}]`);
        if (destination && source) {
          destination.innerHTML = source.innerHTML;
        }
      });
    }

    get selectedOptionValues() {
      return Array.from(this.querySelectorAll('.variant-block input:checked')).map(
        ({ dataset }) => dataset.optionValueId
      );
    }
  }

  customElements.define('variant-selects', VariantSelects);

  document.addEventListener('input', (event) => {
    const input = event.target.closest('[data-char-limit-input]');
    if (!input) return;
    const counter = input.parentElement.querySelector('[data-char-count]');
    if (!counter) return;
    counter.textContent = `${input.value.length}/${input.maxLength}`;
    if (input.matches('[data-personalization-input]')) {
      const wrapper = input.closest('[data-personalization-block]');
      if (wrapper && input.value.trim() !== '') {
        const errorEl = wrapper.querySelector('[data-personalization-error]');
        input.classList.remove('has-error');
        if (errorEl) {
          errorEl.hidden = true;
          errorEl.textContent = '';
        }
      }
    }
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const sectionId = event?.data?.sectionId;
      if (!sectionId) return;
      const wrapper = document.querySelector(`[data-personalization-${sectionId}]`);
      const input = wrapper ? wrapper.querySelector('[data-personalization-input]') : null;
      const errorEl = wrapper ? wrapper.querySelector('[data-personalization-error]') : null;
      if (input) input.classList.remove('has-error');
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-product"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    observer = undefined;

    constructor() {
      super();
    }

    connectedCallback() {
      this.initializeRecommendations(this.dataset.productId);
    }

    initializeRecommendations(productId) {
      this.observer?.unobserve(this);
      this.observer = new IntersectionObserver(
        (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
          this.loadRecommendations(productId);
        },
        { rootMargin: '0px 0px 400px 0px' }
      );
      this.observer.observe(this);
    }

    loadRecommendations(productId) {
      fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations?.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            // Related Product Swiper
            window.initSwiper(
              '.related-product-swiper-' + this.dataset.sectionId,
              {
                slidesPerView: 3.2,
                spaceBetween: 8,
                loop: false,
                pagination: {
                  el: '.swiper-pagination',
                  clickable: true,
                },
                navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                  900: { slidesPerView: 3.608691 },
                  700: { slidesPerView: 2.6 },
                  576: { slidesPerView: 2.2 },
                  426: { slidesPerView: 1.5 },
                  319: { slidesPerView: 1.25 },
                },
              },
              'related-product-' + this.dataset.sectionId
            );
          } else {
            this.closest('.related-product-section').remove();
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
